import { cn } from '@/lib/tailwind'
import type { PromptCategory } from './meta'

const CATEGORY_LABELS: Record<PromptCategory, string | null> = {
  'daily-checkin': 'Check-in',
  'joy-gratitude': 'Gratitude',
  'challenge-anxiety': 'Challenge',
  accomplishment: 'Accomplishment',
  'people-connection': 'Connection',
  'self-awareness': 'Self-awareness',
  'hyperfocus-energy': 'Energy',
  'emotional-reaction': 'Emotion',
  'weekly-review': 'Weekly review',
  open: null,
}

interface PromptBadgeProps {
  category: PromptCategory
  className?: string
}

/**
 * Subtle category badge for prompt-linked entries in the feed.
 * Returns null for the 'open' category.
 */
export function PromptBadge({ category, className }: PromptBadgeProps) {
  const label = CATEGORY_LABELS[category]
  if (!label) return null

  return (
    <span
      className={cn(
        'text-muted-foreground/50 bg-muted/30 rounded-full px-2 py-0.5 text-[10px]',
        className,
      )}
      data-testid="prompt-badge"
    >
      {label}
    </span>
  )
}
